export default "__VITE_ASSET__ff1a4f93__"